import { render, staticRenderFns } from "./employee-add.vue?vue&type=template&id=085a0097"
import script from "./employee-add.vue?vue&type=script&lang=js"
export * from "./employee-add.vue?vue&type=script&lang=js"
import style0 from "./employee-add.vue?vue&type=style&index=0&id=085a0097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports